module.exports = require("immutable");


//////////////////
// WEBPACK FOOTER
// external "immutable"
// module id = 6
// module chunks = 0 1 3